import { AreaChart } from '@mantine/charts';
import { Stack } from 'src/design/atoms/Stack';
import { Text } from 'src/design/atoms/Text';
import React, { useMemo } from 'react';
import { AdminStatsDailyPointDto } from 'src/api/FiretrolApiClient';
import { formatCurrency, formatDate } from 'src/utils';

export interface ICostTrendChartProps {
  daily: AdminStatsDailyPointDto[];
}

export const CostTrendChart: React.FC<ICostTrendChartProps> = ({ daily }) => {
  const data = useMemo(
    () =>
      daily.map((point) => ({
        date: formatDate(point.date, 'MM/DD'),
        'Est. Cost': point.estCostUsd,
      })),
    [daily],
  );

  return (
    <Stack gap={4}>
      <Text size="xs" fw={600} tt="uppercase" c="gray.7">
        Daily cost
      </Text>
      <AreaChart
        h={220}
        data={data}
        dataKey="date"
        series={[{ name: 'Est. Cost', color: 'blue' }]}
        curveType="monotone"
        valueFormatter={(value) => formatCurrency(value, { precise: true })}
        withGradient
        tickLine="y"
        gridAxis="xy"
      />
    </Stack>
  );
};
